import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from '@cutilei/ui'
import AuthValidator from 'components/AuthValidator'
import ErrorBoundary from 'components/ErrorBoundary'
import { BANKING_ENABLED, WHATSAPP_ENABLED } from 'services/features'

import Homepage from 'pages/Homepage'
import MemberRoute from 'components/Routes/MemberRoute'
import BusinessRoute from 'components/Routes/BusinessRoute'
import WhatsappRoute from 'components/Routes/WhatsappRoute'
import CompanyRoute from 'components/Routes/CompanyRoute'
import AdminRoute from 'components/Routes/AdminRoute'
import SignIn from 'pages/SignIn'
import SignUp from 'pages/SignUp'
import Agenda from 'pages/Agenda'
import Customers from 'pages/Customers'
import Schedules from 'pages/Schedules'
import Dashboard from 'pages/Dashboard'
import Config from 'pages/Config'
import EditProfessional from 'pages/EditProfessional'
import AddProfessional from 'pages/AddProfessional'
import BusinessRatings from 'pages/Ratings/Business'
import ProfessionalRatings from 'pages/Ratings/Professional'
import Financial from 'pages/Financial'
import Banking from 'pages/Banking'
import Whatsapp from 'pages/Whatsapp'
import TotalEarnings from 'pages/Financial/Comissions/Total'
import DailyEarnings from 'pages/Financial/Comissions/Daily'
import ForgotPassword from 'pages/ForgotPassword'
import ScheduleLink from 'pages/ScheduleLink'
import Confirmed from 'pages/ScheduleLink/Confirmed'
import CustomerSchedules from 'pages/CustomerSchedules'
import ConfirmSchedule from 'pages/ConfirmSchedule'
import PrivacyPolicy from 'pages/PrivacyPolicy'
import Terms from 'pages/Terms'

import CompanySignIn from 'pages/Company/SignIn'
import CompanySignUp from 'pages/Company/SignUp'
import Home from 'pages/Company/Home'
import CompanyBusinesses from 'pages/Company/Businesses'
import CompanyConfig from 'pages/Company/Config'
import NewSubscription from 'pages/Company/NewSubscription'

import MemberArea from 'pages/Member'
import MemberBusinesses from 'pages/Member/Businesses'
import MemberSchedules from 'pages/Member/Schedules'
import MemberFavorites from 'pages/Member/Favorites'
import MemberUserData from 'pages/Member/UserData'

import AdminSignIn from 'pages/Admin/SignIn'
import AdminFinancial from 'pages/Admin/Financial'
import AdminDailyEarnings from 'pages/Admin/Financial/Earnings/Daily'
import AdminDailyExpenses from 'pages/Admin/Financial/Expenses/Daily'
import AdminMonthlyExpenses from 'pages/Admin/Financial/Expenses/Monthly'
import Businesses from 'pages/Admin/Businesses'
import Members from 'pages/Admin/Members'
import AdminDashboard from 'pages/Admin/Dashboard'
import AuditLogs from 'pages/Admin/AuditLogs'
import AdminConfig from 'pages/Admin/Config'
import AdminPayouts from 'pages/Admin/Payouts'
import NewService from 'pages/Admin/Config/Services/NewService'
import EditService from 'pages/Admin/Config/Services/EditService'
import NewProduct from 'pages/Admin/Config/Products/NewProduct'
import EditProduct from 'pages/Admin/Config/Products/EditProduct'
import NewServiceCategory from 'pages/Admin/Config/ServiceCategories/NewServiceCategory'
import EditServiceCategory from 'pages/Admin/Config/ServiceCategories/EditServiceCategory'
import NewProductCategory from 'pages/Admin/Config/ProductCategories/NewProductCategory'
import EditProductCategory from 'pages/Admin/Config/ProductCategories/EditProductCategory'

export default function App () {
  return (
    <Router>
      <ErrorBoundary>
        <AuthValidator>
          <Routes>
            <Route path='/' element={<Homepage/>}/>
            <Route path='/login' element={<SignIn/>}/>
            <Route path='/signup' element={<SignUp/>}/>
            <Route path='/forgot-password' element={<ForgotPassword/>}/>
            <Route path='/terms' element={<Terms/>}/>
            <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>
  
            <Route path='/member/login' element={<SignIn/>}/>
            <Route path='/member' element={<MemberRoute><MemberArea/></MemberRoute>}/>
            <Route path='/member/member-businesses' element={<MemberRoute><MemberBusinesses/></MemberRoute>}/>
            <Route path='/member/member-favorites' element={<MemberRoute><MemberFavorites/></MemberRoute>}/>
            <Route path='/member/member-schedules' element={<MemberRoute><MemberSchedules/></MemberRoute>}/>
            <Route path='/member/member-userdata' element={<MemberRoute><MemberUserData/></MemberRoute>}/>
  
            <Route path='/business' element={<BusinessRoute><Agenda/></BusinessRoute>}/>
            <Route path='/business/customers' element={<BusinessRoute><Customers/></BusinessRoute>}/>
            <Route path='/business/schedules' element={<BusinessRoute><Schedules/></BusinessRoute>}/>
            <Route path='/business/dashboard' element={<BusinessRoute><Dashboard/></BusinessRoute>}/>
            <Route path='/business/config' element={<BusinessRoute><Config/></BusinessRoute>}/>
            <Route path='/business/add-professional' element={<BusinessRoute><AddProfessional/></BusinessRoute>}/>
            <Route path='/business/professionals/:id/edit' element={<BusinessRoute><EditProfessional/></BusinessRoute>}/>
            <Route path='/business/ratings' element={<BusinessRoute><BusinessRatings/></BusinessRoute>}/>
            <Route path='/business/professionals/:id/ratings' element={<BusinessRoute><ProfessionalRatings/></BusinessRoute>}/>
            <Route path='/business/financial' element={<BusinessRoute><Financial/></BusinessRoute>}/>
            <Route path='/business/financial/total' element={<BusinessRoute><TotalEarnings/></BusinessRoute>}/>
            <Route path='/business/financial/daily' element={<BusinessRoute><DailyEarnings/></BusinessRoute>}/>
            {/*
              O Cutilei Pay ainda não foi lançado: em produção a rota nem é registrada, e
              `/business/banking` digitado na mão cai no curinga. Ver `services/features.js`.
              O `/*` cobre os endereços das operações, que a página lê da URL.
            */}
            {BANKING_ENABLED && (
              <Route path='/business/banking/*' element={<BusinessRoute><Banking/></BusinessRoute>}/>
            )}
            {/* Gestão WhatsApp: em teste, fora de produção e só para salão liberado. Ver `services/features.js`. */}
            {WHATSAPP_ENABLED && (
              <Route path='/business/whatsapp' element={<BusinessRoute><WhatsappRoute><Whatsapp/></WhatsappRoute></BusinessRoute>}/>
            )}
            <Route path='/businesses/:business_id/schedule' element={<ScheduleLink/>}/>
            <Route path='/businesses/:business_id/schedule/:schedule_id' element={<ScheduleLink/>}/>
            <Route path='/schedule/success' element={<Confirmed/>}/>
            <Route path='/customers/:customer_id/schedules' element={<CustomerSchedules/>}/>
            <Route path='/schedules/:schedule_id/confirm' element={<ConfirmSchedule/>}/>
  
            <Route path='/company/login' element={<CompanySignIn/>}/>
            <Route path='/company/signup' element={<CompanySignUp/>}/>
            <Route path='/company' element={<CompanyRoute><Home/></CompanyRoute>}/>
            <Route path='/company/businesses' element={<CompanyRoute><CompanyBusinesses/></CompanyRoute>}/>
            <Route path='/company/config' element={<CompanyRoute><CompanyConfig/></CompanyRoute>}/>
            <Route path='/company/new_subscription' element={<CompanyRoute><NewSubscription/></CompanyRoute>}/>
  
            <Route path='/admin/login' element={<AdminSignIn/>}/>
            <Route path='/admin' element={<AdminRoute><AdminFinancial/></AdminRoute>}/>
            <Route path='/admin/earnings/daily' element={<AdminRoute><AdminDailyEarnings/></AdminRoute>}/>
            <Route path='/admin/expenses/monthly' element={<AdminRoute><AdminMonthlyExpenses/></AdminRoute>}/>
            <Route path='/admin/expenses/daily' element={<AdminRoute><AdminDailyExpenses/></AdminRoute>}/>
            <Route path='/admin/businesses' element={<AdminRoute><Businesses/></AdminRoute>}/>
            <Route path='/admin/members' element={<AdminRoute><Members/></AdminRoute>}/>
            <Route path='/admin/dashboard' element={<AdminRoute><AdminDashboard/></AdminRoute>}/>
            <Route path='/admin/config' element={<AdminRoute><AdminConfig/></AdminRoute>}/>
            <Route path='/admin/audit_logs' element={<AdminRoute><AuditLogs/></AdminRoute>}/>
            {/*
              O repasse automático faz parte do Cutilei Pay, que ainda não foi lançado: em
              produção a rota nem é registrada, e `/admin/payouts` digitado na mão cai no
              curinga. Ver `services/features.js`.
            */}
            {BANKING_ENABLED && (
              <Route path='/admin/payouts' element={<AdminRoute><AdminPayouts/></AdminRoute>}/>
            )}
            <Route path='/admin/services/new' element={<AdminRoute><NewService/></AdminRoute>}/>
            <Route path='/admin/services/:id/edit' element={<AdminRoute><EditService/></AdminRoute>}/>
            <Route path='/admin/products/new' element={<AdminRoute><NewProduct/></AdminRoute>}/>
            <Route path='/admin/products/:id/edit' element={<AdminRoute><EditProduct/></AdminRoute>}/>
            <Route path='/admin/service_categories/new' element={<AdminRoute><NewServiceCategory/></AdminRoute>}/>
            <Route path='/admin/service_categories/:id/edit' element={<AdminRoute><EditServiceCategory/></AdminRoute>}/>
            <Route path='/admin/product_categories/new' element={<AdminRoute><NewProductCategory/></AdminRoute>}/>
            <Route path='/admin/product_categories/:id/edit' element={<AdminRoute><EditProductCategory/></AdminRoute>}/>
  
            <Route path='*' element={<Navigate to='/' replace/>}/>
          </Routes>
        </AuthValidator>
      </ErrorBoundary>
      {/* Os avisos do `toast()` do @cutilei/ui, de qualquer tela. */}
      <Toaster/>
    </Router>
  )
}
